import getNativeQuestions from './View/getNativeQuestions';
import { RETAINER_ATTRIBUTES, RETAINER_QUESTIONS, RETAINER_VIEW_LABEL } from './constants';

const retainerView = {
  getNativeQuestions,
  pinnedFields: [RETAINER_ATTRIBUTES.DOCTOR, 'tracking_number'],
  viewLabels: RETAINER_VIEW_LABEL,
  questions: RETAINER_QUESTIONS,
  attributeValueLabels: {},
  showTeeth: false
};

export default retainerView;
